import type { User } from 'features/auth';
import type { GivingContentObjectDetail } from '../../models';
import {
  isCommunitiesAdmin,
  isCommunityAdminProfile,
  isOrganizationAdminProfile,
  isOrganizationsAdmin,
  isSuperAdmin,
} from '../utils';

export const canViewAdminDashboardGivings = ({ viewer }: { viewer: User }) =>
  isSuperAdmin({ viewer: viewer.railsUserData }) ||
  isOrganizationsAdmin({ viewer: viewer.railsUserData }) ||
  isCommunitiesAdmin({ viewer: viewer.railsUserData });

export const canViewGivingInAdmin = ({
  givingContentObject,
  viewer,
}: {
  givingContentObject: GivingContentObjectDetail;
  viewer: User;
}) =>
  isSuperAdmin({ viewer: viewer.railsUserData }) ||
  isOrganizationAdminProfile({ organizationId: givingContentObject.organization.id, viewer: viewer.railsUserData }) ||
  isCommunityAdminProfile({ communityId: givingContentObject.postInCommunities[0].id, viewer: viewer.railsUserData });

export const canViewNonProfitGiving = ({ viewer }: { viewer: User }) =>
  Boolean(viewer.railsUserData.permissions.viewNonProfitGiving);

export const canViewProfitGiving = ({ viewer }: { viewer: User }) =>
  Boolean(viewer.railsUserData.permissions.viewProfitGiving);
